import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { BlockIcon } from '@wordpress/block-editor';
import BlockRatings from '../block-ratings';

function DownloadableBlockHeader(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      rating = _ref.rating,
      ratingCount = _ref.ratingCount,
      _onClick = _ref.onClick;
  return createElement("div", {
    className: "block-directory-downloadable-block-header__row"
  }, icon.match(/\.(jpeg|jpg|gif|png)$/) !== null ? createElement("img", {
    src: icon,
    alt: "block icon"
  }) : createElement("span", null, createElement(BlockIcon, {
    icon: icon,
    showColors: true
  })), createElement("div", {
    className: "block-directory-downloadable-block-header__column"
  }, createElement("span", {
    role: "heading",
    className: "block-directory-downloadable-block-header__title"
  }, title), createElement(BlockRatings, {
    rating: rating,
    ratingCount: ratingCount
  })), createElement(Button, {
    isDefault: true,
    onClick: function onClick(event) {
      event.preventDefault();

      _onClick();
    }
  }, __('Add')));
}

export default DownloadableBlockHeader;
//# sourceMappingURL=index.js.map